import React from 'react';

import * as copy from '../constants/copy';
import * as styles from './ReviewPhotosRail.styles';

export interface ReviewPhotoLink {
  alt: string;
  /** The photo's review in full: this drawer, deep-linked to it. */
  href: string;
  key: string;
  url: string;
}

export interface ReviewPhotosRailProps {
  photos: ReviewPhotoLink[];
}

/**
 * The reviews' customer photos in one sideways-scrolling row. Each photo leads to its
 * review in full rather than opening a gallery. `overscroll-behavior-x: contain` stops a
 * swipe past the end reaching the page, where on iOS it is a back gesture.
 */
export const ReviewPhotosRail = ({ photos }: ReviewPhotosRailProps) => (
  <section aria-labelledby="reviews-drawer-photos-heading" css={styles.section}>
    <h3 css={styles.heading} id="reviews-drawer-photos-heading">
      {copy.PHOTOS_HEADING}
    </h3>
    <ul css={styles.track} data-testid="reviews-drawer-photos">
      {photos.map(({ alt, href, key, url }) => (
        <li css={styles.item} key={key}>
          <a css={styles.tile} href={href}>
            <img alt={alt} css={styles.image} loading="lazy" src={url} />
          </a>
        </li>
      ))}
    </ul>
  </section>
);

ReviewPhotosRail.displayName = 'ReviewPhotosRail';
